import * as Yup from "yup";

export const initialValues = {
  subject: null,
  description: null,
  announcementType: null,
  startAnnounce: null,
  departmentId: null,
  audienceGroup: [],
  statusFlag: '',
};

export const ANNOUNCEMENT_TYPE = {
  BROADCAST_NOW: "BROADCAST_NOW",
  SCHEDULE: "SCHEDULE",
};

const newsSchema = Yup.object().shape({
  subject: Yup.string().required("Please enter."),
  description: Yup.string().required("Please enter."),
  announcementType: Yup.string().required("Please select."),
  startAnnounce: Yup.date().when("announcementType", {
    is: (val) => val === ANNOUNCEMENT_TYPE.SCHEDULE,
    then: () => Yup.string().required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
  departmentId: Yup.array().required("Please select."),
  audienceGroup: Yup.array().required("Please select."),
  newsCode: Yup.string().required("Please select."),
  employeeTypeId: Yup.array().required("Please select.")
});

export default newsSchema;
